import { useAuth0 } from '@auth0/auth0-react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { BlankScreen } from '@strata/react-page-templates';
import dayjs from 'dayjs';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { getFMHTokenAndEnsureSocketConnections } from 'services/authHelpers';
import { LOGIN_REDIRECT_KEY, TOKEN_FETCHED_AT } from 'services/constants';
import { identifyLaunchDarklyUser } from 'services/launchDarkly';
import { initializePendo } from 'services/pendoUtils';
import { AppRoutes } from 'services/routes';

/**
 * Component to be rendered on callback from Auth0.
 * Handles authentication of the user and redirects to /home.
 */
export const AuthCallback = () => {
    const { isLoading, user, getAccessTokenSilently, logout } = useAuth0();
    const ldClient = useLDClient();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        void (async () => {
            if (!isLoading && !!user) {
                const fmhTokenResult = await getFMHTokenAndEnsureSocketConnections({
                    getAccessTokenSilently,
                    logout,
                    dispatch,
                });
                localStorage.setItem(TOKEN_FETCHED_AT, dayjs().toISOString());

                datadogRum.setUser({ id: user.email, email: user.email, name: user.name });
                datadogLogs.logger.info('User Authenticated', { user });
                await identifyLaunchDarklyUser(ldClient, user);
                initializePendo(fmhTokenResult, user);
                const redirectPath = sessionStorage.getItem(LOGIN_REDIRECT_KEY);
                navigate(redirectPath ?? AppRoutes.home);
            }
        })();
    }, [isLoading, user, dispatch, navigate, logout, getAccessTokenSilently, ldClient]);

    return <BlankScreen />;
};
